// extracted by mini-css-extract-plugin
export default {"descriptionRow":"cVgzGVJvpXJ4FlLmYABq","formBox":"dEt7veqOVxXVKvJB3h45","btnRow":"LczxeoVrnVgUMwGq7LgN"};